export function UpInCircle(): React.ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75ZM8 1.75C11.4531 1.75 14.25 4.54688 14.25 8C14.25 11.4531 11.4531 14.25 8 14.25C4.54688 14.25 1.75 11.4531 1.75 8C1.75 4.54688 4.54688 1.75 8 1.75ZM8.625 12H7.375C7.16875 12 7 11.8313 7 11.625V8H4.90625C4.57188 8 4.40625 7.59688 4.64062 7.35938L7.73438 4.26562C7.88125 4.11875 8.11875 4.11875 8.26562 4.26562L11.3594 7.35938C11.5969 7.59688 11.4281 8 11.0938 8H9V11.625C9 11.8313 8.83125 12 8.625 12Z"
        fill="black"
      />
    </svg>
  );
}
